import React from 'react';
import Layout from '../components/Layout';
import PromotionsSection from '../components/PromotionsSection';
import { Star, Sparkles } from 'lucide-react';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/a1abbu6u_WhatsApp%20Image%202026-03-26%20at%2012.30.52.jpeg";

const PromotionsPage = () => {
  return (
    <Layout>
      <div className="min-h-screen" style={{ backgroundColor: '#F4EFE6', paddingTop: '76px' }} data-testid="promotions-page">
        {/* Hero Banner */}
        <div className="relative" style={{ borderBottom: '4px solid #1A1918' }}>
          <div className="relative h-[280px] sm:h-[320px] lg:h-[380px] overflow-hidden">
            <img src={HERO_IMAGE} alt="Casa Loco Interior" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A1918] via-black/50 to-transparent" />
          </div>
          <div className="absolute bottom-0 left-0 right-0 pb-8 pt-16 text-center">
            <div className="flex items-center justify-center gap-4 mb-3">
              <Star size={10} fill="#F7B638" stroke="none" />
              <Sparkles style={{ width: '36px', height: '36px', color: '#F7B638' }} />
              <Star size={10} fill="#F7B638" stroke="none" />
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mb-3" style={{ textShadow: '3px 3px 0 rgba(0,0,0,0.5)' }} data-testid="promotions-page-title">
              WEEKLY FIESTAS
            </h1>
            <div className="zigzag-divider-gold max-w-xs mx-auto mb-4" />
            <p className="font-mono text-white/80 text-sm max-w-lg mx-auto">
              Three signature experiences that bring the spirit of Mexico to Hyderabad
            </p>
          </div>
        </div>

        <PromotionsSection />
      </div>
    </Layout>
  );
};

export default PromotionsPage;
